import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Event } from '@app/core/interfaces';

//Open Layers
import TileLayer from 'ol/layer/Tile';
import { OSM, Zoomify } from 'ol/source';
import { Feature, Map as OpMap, Overlay, View } from 'ol/';
import { EventsService } from '@app/services/events.service';
import { getCenter } from 'ol/extent';
import { Projection } from 'ol/proj';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import { MapRenderService } from '@app/services/map-render.service';
import { format, parseISO } from 'date-fns';
import { WebSocketService } from '@app/services/websocket.service';

/*
 *
 * GPS MAP DRAWING NOT YET INCLUDED IN THIS COMPONENT
 * NEITHER IS ANIMATED FEATURES
 *
 */

@Component({
  selector: 'app-persistent-alert-card',
  templateUrl: './persistent-alert-card.component.html',
  styleUrl: './persistent-alert-card.component.scss',
})
export class PersistentAlertCardComponent implements OnInit, AfterViewInit {
  //Input info
  @Input() selectedAlert!: Event;
  @Output() public closeClick = new EventEmitter();

  //Open layers
  @ViewChild('mapElement') mapElement!: ElementRef;
  map!: OpMap;
  view!: View;
  tileLayer!: TileLayer;
  projection!: Projection;
  extent: [number, number, number, number] = [0, 0, 1000, 1000];

  loading: boolean = false;

  //Form
  optionalComment: string = '';

  constructor(
    public alertService: EventsService,
    private renderService: MapRenderService,
    private socketService: WebSocketService
  ) { }

  ngOnInit(): void {
    //console.log(this.selectedAlert);
  }

  ngAfterViewInit(): void {
    if (this.selectedAlert.MapId) {
      this.alertService
        .getMapById(this.selectedAlert.MapId)
        .subscribe((res: any) => {
          //console.log(res);
          this.extent = [0, 0, res.Width, res.Height];
          this.draw2DMap();
        });
    } else {
      console.log('handle no map error');
    }
  }

  draw2DMap() {
    this.projection = new Projection({
      code: 'EPSG:4326',
      units: 'pixels',
      extent: this.extent,
    });

    this.view = new View({
      projection: this.projection,
      center: getCenter([0, 0, this.extent[2], -this.extent[3]]), //mkl 2/14/2024
      zoom: 2,
      minZoom: -1,
      maxZoom: 4,
    });

    this.tileLayer = new TileLayer({
      source: new Zoomify({
        url: `/maps/${this.selectedAlert.MapId}/${this.selectedAlert.MapId}/`,
        size: [this.extent[2], this.extent[3]],
        tierSizeCalculation: 'truncated',
      }),
      zIndex: 1,
    });

    //2D event feature
    let eventFeature = this.renderService.createIconEventFeature(
      this.selectedAlert,
      false
    );
    //console.log(eventFeature);

    let eventLayer = new VectorLayer<any>({
      source: new VectorSource({ features: [eventFeature] }),
      zIndex: 15,
    });

    this.map = new OpMap({
      layers: [this.tileLayer, eventLayer],
      target: this.mapElement.nativeElement,
      view: this.view,
    });
    this.map.once('postrender', () => {
      this.zoomTo();
    });
  }

  formatTime(date: string): string {
    if (date) {
      const formatDate = format(parseISO(date + 'Z'), 'MMM do h:mm aaa');
      return `${formatDate}`;
    }
    return '';
  }

  acknowledgeAlert() {
    this.loading = true;
    if (this.optionalComment == '') {
      this.optionalComment = 'No comment provided.';
    }
    this.alertService
      .acknowledgeEvent(this.selectedAlert.Id, this.optionalComment)
      .subscribe(
        (res: any) => {
          //console.log(res);
          this.socketService.perAlerts = this.socketService.perAlerts.filter(
            (alert: any) => {
              return alert.Id !== this.selectedAlert.Id;
            }
          );

          //find the alert in socketService.allAlerts and change its condition
          for (let i = 0; i < this.socketService.allAlerts.length; i++) {
            if (this.socketService.allAlerts[i].Id == this.selectedAlert.Id) {
              this.socketService.allAlerts[i].IsAcknowledged = true;
              this.socketService.allAlerts[i].Status = 'Acknowledged';
            }
          }

          this.loading = false;
          this.closeClick.emit();
        },
        (err: any) => {
          this.loading = false;
        }
      );
  }

  zoomTo() {
    this.map
      .getView()
      .fit(
        [
          this.selectedAlert.X,
          -this.selectedAlert.Y,
          this.selectedAlert.X,
          -this.selectedAlert.Y,
        ],
        { minResolution: 1 }
      );
  }
}
